import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Slider.scss";
import SlideImage1 from "../../assets/images/sjm image 1.jpg";
import SlideImage2 from "../../assets/images/sjm image 1.jpg";
import SlideImage3 from "../../assets/images/sjm image 1.jpg";

const ImageSlider: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    centerMode: false,    // Disable center mode to prevent overflows
    variableWidth: false,
    adaptiveHeight: true,
    beforeChange: (oldIndex: number, newIndex: number) => {
      setCurrentSlide(newIndex); // Track the current slide
    },
  };

  // Images and their associated animation styles
  const slides = [
    { src: SlideImage1, animation: "fade" },
    { src: SlideImage2, animation: "slide-right" },
    { src: SlideImage3, animation: "box" },
  ];

  return (
    <div className="slider-container">
      <Slider {...sliderSettings}>
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${currentSlide === index ? slide.animation : ""}`}
          >
            <img src={slide.src} alt={`Slide ${index + 1}`} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;
